import { Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'

// Components
import Loading from '../../Components/shared/Loading/LoadingApp'
import MlsDisclaimers from '../../features/mlsDisclaimers'

export interface MatchProps {
  url: string
  params: { [key: string]: string }
  isExact: boolean
  path: string
}

export interface MlsDisclaimersRouteProps {
  match: MatchProps
}

export const MlsDisclaimersRoute = ({ match }: MlsDisclaimersRouteProps) => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={match.url} component={MlsDisclaimers} />
      </Switch>
    </Suspense>
  )
}
